// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__3GVmN","label":"CategoryService_label__3kl0G","location":"CategoryService_location__3I-S9"};